module.exports = __webpack_public_path__ + "static/fosters-746ed867a00e7a30a71db05aae7f6849.jpg";